import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Disclaimer from "../components/Disclaimer";
import SEO from "../components/SEO";
import Breadcrumbs from "../components/Breadcrumbs";

export default function Goals() {
  const [goals, setGoals] = useState([]);
  useEffect(() => { api.get("/goals").then(({ data }) => setGoals(data)); }, []);
  return (
    <div data-testid="goals-page">
      <SEO
        title="Treatment Goals & Peptide Therapy Categories"
        description="Explore treatment goals — weight, hormones, recovery, longevity, hair, cognition, and more. Each goal shows educational peptide pathways a licensed provider may evaluate."
        path="/treatment-goals"
        breadcrumbs={[{ name: "Treatment Goals", path: "/treatment-goals" }]}
      />
      <section className="vv-hero">
        <div className="vv-container py-16">
          <Breadcrumbs items={[{ name: "Treatment Goals", path: "/treatment-goals" }]} />
          <div className="vv-hero-eyebrow mb-2">Treatment Goals</div>
          <h1 className="font-display text-4xl md:text-5xl">Where do you want to focus?</h1>
          <p className="mt-4 text-stone-600 max-w-2xl">Each goal shows educational pathways a provider may evaluate — never an automatic prescription.</p>
        </div>
      </section>
      <section className="vv-container py-14">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {goals.map((g) => (
            <Link key={g.slug} to={`/treatment-goals/${g.slug}`} data-testid={`goal-card-${g.slug}`} className="vv-card p-6 block">
              <div className="font-display text-xl">{g.name}</div>
              <div className="text-sm text-stone-600 mt-2 leading-relaxed">{g.description}</div>
              <div className="text-xs uppercase tracking-widest text-[color:var(--vv-teal)] mt-4">Explore →</div>
            </Link>
          ))}
        </div>
        <div className="mt-14"><Disclaimer /></div>
      </section>
    </div>
  );
}
